import { RRule } from 'rrule'

import i18n from 'modules/core/lib/i18n'
import { Model } from 'modules/core/lib/mobx-rest'

interface PeriodicityDataProps {
  label: string
  recurrence: string
}

export type PeriodicityType = 'monthly' | 'every_2_weeks' | 'twice_a_month' | 'weekly'

export const MONTHLY = 'monthly'
interface IPolicy {
  id?: string
  name: string
  starts_on: string
  periodicity?: string
  recurrence: string
  default?: boolean
  company_id?: string
  archived_at?: Date
  country?: string
  currency?: string
}

class Policy extends Model<IPolicy> {
  static urlRoot() {
    return '/payroll/policies'
  }

  static periodicities: () => { [key in PeriodicityType]: PeriodicityDataProps } = () => ({
    monthly: {
      recurrence: 'FREQ=MONTHLY;BYMONTHDAY=1',
      label: i18n.t('payroll_bundle.payroll_policy.periodicity.monthly'),
    },
    every_2_weeks: {
      recurrence: 'FREQ=WEEKLY;INTERVAL=2;WKST=SU',
      label: i18n.t('payroll_bundle.payroll_policy.periodicity.every_2_weeks'),
    },
    twice_a_month: {
      recurrence: 'FREQ=MONTHLY;BYMONTHDAY=1,15',
      label: i18n.t('payroll_bundle.payroll_policy.periodicity.twice_a_month'),
    },
    weekly: {
      recurrence: 'FREQ=WEEKLY;BYDAY=MO',
      label: i18n.t('payroll_bundle.payroll_policy.periodicity.weekly'),
    },
  })

  static periodicityByRecurrence = (recurrence: string) => {
    const periodicities = Policy.periodicities()

    return Object.values(periodicities).find(
      (value: PeriodicityDataProps) => value.recurrence === recurrence
    )
  }

  static periodicityKeyByRecurrence = (recurrence: string) => {
    const periodicities = Policy.periodicities()

    return Object.keys(periodicities).find((key) => {
      const value = periodicities[key as PeriodicityType]

      return value.recurrence === recurrence
    })
  }

  recurrenceRule(): RRule {
    const options = RRule.parseString(this.get('recurrence'))
    options.dtstart = new Date(Date.parse(this.get('starts_on')))

    return new RRule(options)
  }
}

export default Policy
